import PigeonDocNodeModel from '../../models/PigeonDocNodeModel';
import Chart from './chart.js';

export default {
  props: {
    value: PigeonDocNodeModel,
  },
  data() {
    return {
      chart: new Chart(),
    };
  },
  mounted() {
    this.createChart();
    window.addEventListener('resize', () => {
      clearTimeout(this.windowResizeTimeout);

      this.windowResizeTimeout = setTimeout(() => {
        this.chart.empty(this.$refs['chart']);
        this.createChart();
      }, 1000);
    });
  },
  methods: {
    createChart() {
      this.chart.create(this.$refs['chart'], this.value.content.data, {
        primaryColour: this.value.meta.primaryBarColour,
        highlightColour: this.value.meta.highlightBarColour,
        meanLineColour: this.value.meta.meanLineColour,
        axisLabels: this.value.meta.axisLabels,
        suffix: this.value.meta.suffix,
        groupAverage: this.value.meta.groupAverage,
      });
    },
  },
};
